export const checkIfWebsiteHasBlackPalette = (currentWebsite:any) => {
    return currentWebsite.color_classname.indexOf('style-black') !== -1;
};